import React from 'react'
import { Vehicle } from '../../../models/vehicle/Vehicle'
import { BsCarFront, BsImageFill } from 'react-icons/bs'
import { getPhoneNumberFromShortCodeFormat } from '../../../utils/miscFunctions'
import ImageGallery from '../../../components/elements/imageViewer/ImageGallery'


interface IVehicle {
    vehicle:Vehicle | undefined;
}
const VehicleInfo =({vehicle}:IVehicle) => {

    const formatCurrency = (amount: number) => {
        return new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',
            minimumFractionDigits: 2
        }).format(amount);
    };
    
  return (
    <div>
          <div className="bg-white rounded-2xl shadow overflow-hidden dark:!text-darkBg-mainText dark:bg-darkBg dark:border dark:border-darkBg-border">
            <div className="px-6 py-4 border-b border-gray-200 bg-gray-50 dark:bg-darkBg dark:border-darkBg-border">
                <h2 className="text-lg font-medium text-gray-900 flex items-center dark:text-darkBg-mainText">
                    <BsCarFront className="h-5 w-5 mr-2 text-gray-500 dark:text-darkBg-mainText" />
                    Vehicle Information
                </h2>
            </div>

            <div className="p-6">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
                    <div className="col-span-1">
                        <div className="bg-gray-50 p-4 rounded-lg h-full dark:bg-transparent dark:!text-darkBg-mainText dark:border dark:border-darkBg-border">
                            <h3 className="text-md font-medium text-gray-900 mb-3 dark:text-darkBg-mainText">Vehicle Details</h3>
                            <div className="space-y-3">
                                <div>
                                    <p className="text-sm font-medium text-gray-500">Make</p>
                                    <p className="text-sm text-gray-900 dark:text-darkBg-mainText">{vehicle?.make ?? '-'}</p>
                                </div>
                                <div>
                                    <p className="text-sm font-medium text-gray-500">Model</p>
                                    <p className="text-sm text-gray-900 dark:text-darkBg-mainText">{vehicle?.model ?? '-'}</p>
                                </div>
                                <div>
                                    <p className="text-sm font-medium text-gray-500">Type</p>
                                    <p className="text-sm text-gray-900 dark:text-darkBg-mainText">{vehicle?.type?.name ?? '-'}</p>
                                </div>
                                <div>
                                    <p className="text-sm font-medium text-gray-500">Color</p>
                                    <p className="text-sm text-gray-900 dark:text-darkBg-mainText">{vehicle?.color ?? '-'}</p>
                                </div>
                                <div>
                                    <p className="text-sm font-medium text-gray-500">Chassis / VIN Number</p>
                                    <p className="text-sm text-gray-900 dark:text-darkBg-mainText">{vehicle?.chassisNumber ?? '-'}</p>
                                </div>
                                <div>
                                    <p className="text-sm font-medium text-gray-500">CC</p>
                                    <p className="text-sm text-gray-900 dark:text-darkBg-mainText">{vehicle?.cc ?? '-'}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-span-1">
                        <div className="bg-gray-50 p-4 rounded-lg h-full dark:bg-transparent dark:!text-darkBg-mainText dark:border dark:border-darkBg-border">
                            <h3 className="text-md font-medium text-gray-900 mb-3 dark:text-darkBg-mainText">Registration & Usage</h3>
                            <div className="space-y-3">
                                <div>
                                    <p className="text-sm font-medium text-gray-500">Manufactured Year</p>
                                    <p className="text-sm text-gray-900 dark:text-darkBg-mainText">{vehicle?.manufacturedYear ?? '-'}</p>
                                </div>
                                <div>
                                    <p className="text-sm font-medium text-gray-500">Registration Year</p>
                                    <p className="text-sm text-gray-900 dark:text-darkBg-mainText">{vehicle?.registrationYear ?? '-'}</p>
                                </div>
                                <div>
                                    <p className="text-sm font-medium text-gray-500">Vehicle Registration Number</p>
                                    <p className="text-sm text-gray-900 dark:text-darkBg-mainText">{vehicle?.registrationNumber ?? '-'}</p>
                                </div>
                                <div>
                                    <p className="text-sm font-medium text-gray-500">Vehicle Usage</p>
                                    <p className="text-sm text-gray-900 dark:text-darkBg-mainText">{vehicle?.usage?.title ?? '-'}</p>
                                </div>
                                <div>
                                    <p className="text-sm font-medium text-gray-500">Number of Passengers</p>
                                    <p className="text-sm text-gray-900 dark:text-darkBg-mainText">{'-'}</p>
                                </div>
                                <div>
                                    <p className="text-sm font-medium text-gray-500">Vehicle Region</p>
                                    <p className="text-sm text-gray-900 dark:text-darkBg-mainText">{vehicle?.region ?? '-'}</p>
                                </div>
                            </div>
                        </div>
                    </div>

                   
                </div>
                 <div className="bg-gray-50 rounded-lg h-full p-4 dark:bg-transparent dark:!text-darkBg-mainText dark:border dark:border-darkBg-border">
                        <h3 className="text-md font-medium text-gray-900 mb-3 dark:text-darkBg-mainText">Owner & Value</h3>
                        <div className=" grid grid-cols-3">
                            
                            <div className="space-y-3">
                            <div>
                                    <p className="text-sm font-medium text-gray-500">Vehicle Owner</p>
                                    <p className="text-sm text-gray-900 dark:text-darkBg-mainText">{vehicle?.ownerName || '-'}</p>
                                </div>
                                <div>
                                    <p className="text-sm font-medium text-gray-500">Owner&apos;s Phone</p>
                                    <p className="text-sm text-gray-900 dark:text-darkBg-mainText">{vehicle?.ownerPhoneNumber ? getPhoneNumberFromShortCodeFormat(vehicle?.ownerPhoneNumber) : '-'}</p>
                                </div>
                                <div>
                                    <p className="text-sm font-medium text-gray-500">Vehicle Main Driver</p>
                                    <p className="text-sm text-gray-900 dark:text-darkBg-mainText">{vehicle?.driver?.fullName || '-'}</p>
                                </div>
                            </div>
                            <div className="space-y-3">
                             <div>
                                    <p className="text-sm font-medium text-gray-500">Vehicle Insurance Value</p>
                                    <p className="text-sm text-gray-900 dark:text-darkBg-mainText">{vehicle?.insuredValue ? formatCurrency(vehicle?.insuredValue) : '-'}</p>
                                </div>
                                <div>
                                    <p className="text-sm font-medium text-gray-500">Nature of Interest in Vehicle</p>
                                    <p className="text-sm text-gray-900 dark:text-darkBg-mainText">{vehicle?.natureOfInterest ?? '-'}</p>
                                </div></div>
                            <div className="space-y-3">
                             <div>
                                    <p className="text-sm font-medium text-gray-500">Accessories Installed</p>
                                    <p className="text-sm text-gray-900 dark:text-darkBg-mainText">{vehicle?.installedAccessoriesDetails ?? '-'}</p>
                                </div>
                                <div>
                                    <p className="text-sm font-medium text-gray-500">Accessories Value</p>
                                    <p className="text-sm text-gray-900 dark:text-darkBg-mainText">{vehicle?.installedAccessoriesValue ? formatCurrency(vehicle?.installedAccessoriesValue) : '-'}</p>
                                </div>
                            </div>
                        </div>
                    </div>
            </div>

            {/* Vehicle Pictures Slideshow */}
            {vehicle?.images && vehicle?.images?.length > 0 && (
                <div className="p-6 border-b border-gray-200">
                    <h3 className="text-md font-medium text-gray-900 mb-3 flex items-center">
                        <BsImageFill className="h-4 w-4 mr-2 text-gray-500" />
                        Vehicle Pictures
                    </h3>

                    <ImageGallery
                        images={vehicle?.images || []}
                    />
                </div>
            )}
        </div>
    </div>
  )
}

export default VehicleInfo